var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":("/screensaver/Diapositive" + _vm.current + ".png"),"alt":"","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }